const blogPosts = [
  {
    id: 1,
    slug: "top-cybersecurity-trends-2024",
    postType: "normal",
    title: "Top Cybersecurity Trends to Watch in 2024",
    titleKey: "sections.blogPosts.post_1.title",
    excerpt: "Explore the latest cybersecurity trends shaping the digital landscape in 2024, from AI-powered threats to zero-trust architecture.",
    excerptKey: "sections.blogPosts.post_1.excerpt",
    author: "Secur",
    authorKey: "sections.blogPosts.post_1.author",
    date: "21 Jun, 2025",
    dateKey: "sections.blogPosts.post_1.date",
    image: "assets/img/blog/recent-post-1-1.jpg",
    detailImage: "assets/img/blog/blog-s-1-1.jpg",
    content: {
      intro: "Cloud Security Posture Management (CSPM) is a category of security solutions designed to enhance security of cloud environments by identifying and mitigating risks associated with cloud misconfigurations, compliance violations.",
      introKey: "sections.blogPosts.post_1.content.intro",
      mainContent: "Ransomware attacks have become more targeted, focusing on critical infrastructure and large corporations. Attackers now use double extortion, demanding payment not only for decrypting files but also for not leaking sensitive data.",
      mainContentKey: "sections.blogPosts.post_1.content.mainContent",
      quote: {
        text: "Cybersecurity is the new frontier of technology. To protect our digital lives, we must prioritize security as much as innovation.",
        textKey: "sections.blogPosts.post_1.content.quote.text",
        author: "Satya Nadella",
        authorKey: "sections.blogPosts.post_1.content.quote.author",
        designation: "CEO of Microsoft",
        designationKey: "sections.blogPosts.post_1.content.quote.designation"
      },
      middleContent: "SaaS platforms are increasingly popular among cybercriminals, enabling even non-technical individuals to launch ransomware attacks. APTs involve sophisticated, long-term attacks aimed at compromising systems and stealing information without immediate detection.",
      middleContentKey: "sections.blogPosts.post_1.content.middleContent",
      conclusion: "Cybercriminals are leveraging artificial intelligence to develop smarter malware and conduct social engineering attacks. More convincing phishing emails, automated brute force attacks, and adaptive threats.",
      conclusionKey: "sections.blogPosts.post_1.content.conclusion"
    },
    tags: ["Attack", "Hacking"],
    category: "Cloud Security Management"
  },
  {
    id: 2,
    slug: "ai-in-cybersecurity",
    postType: "video",
    title: "AI in Cybersecurity: A Double-Edged Sword?",
    titleKey: "sections.blogPosts.post_2.title",
    excerpt: "Discover how artificial intelligence is revolutionizing cybersecurity while also creating new challenges and vulnerabilities.",
    excerptKey: "sections.blogPosts.post_2.excerpt",
    author: "Secur",
    authorKey: "sections.blogPosts.post_2.author",
    date: "26 Jul, 2025",
    dateKey: "sections.blogPosts.post_2.date",
    image: "assets/img/blog/recent-post-1-2.jpg",
    detailImage: "assets/img/blog/blog-s-1-2.jpg",
    videoUrl: "https://www.youtube.com/watch?v=_sI_Ps7JSEk",
    content: {
      intro: "Artificial Intelligence is transforming the cybersecurity landscape, offering both unprecedented protection capabilities and new attack vectors for malicious actors.",
      introKey: "sections.blogPosts.post_2.content.intro",
      mainContent: "AI-powered security systems can detect anomalies and threats in real-time, analyzing vast amounts of data faster than any human team. However, cybercriminals are also leveraging AI to create more sophisticated attacks.",
      mainContentKey: "sections.blogPosts.post_2.content.mainContent",
      quote: {
        text: "AI is a fundamental risk to the existence of human civilization in a way that car accidents, airplane crashes, faulty drugs or bad food were not.",
        textKey: "sections.blogPosts.post_2.content.quote.text",
        author: "Elon Musk",
        authorKey: "sections.blogPosts.post_2.content.quote.author",
        designation: "CEO of Tesla & SpaceX",
        designationKey: "sections.blogPosts.post_2.content.quote.designation"
      },
      middleContent: "Machine learning algorithms can identify patterns in network traffic, predict potential breaches, and automate response mechanisms. Yet, adversarial AI can be used to evade detection systems and launch targeted phishing campaigns.",
      middleContentKey: "sections.blogPosts.post_2.content.middleContent",
      conclusion: "The key to leveraging AI in cybersecurity is maintaining a balanced approach - using it as a powerful defensive tool while staying vigilant against AI-enhanced threats.",
      conclusionKey: "sections.blogPosts.post_2.content.conclusion"
    },
    tags: ["AI", "Security"],
    category: "Cloud Workload Protection"
  },
  {
    id: 3,
    slug: "strong-password-guide",
    postType: "gallery",
    title: "The Ultimate Guide to Creating Strong Passwords",
    titleKey: "sections.blogPosts.post_3.title",
    excerpt: "Learn essential techniques and best practices for creating unbreakable passwords to protect your digital identity.",
    excerptKey: "sections.blogPosts.post_3.excerpt",
    author: "Secur",
    authorKey: "sections.blogPosts.post_3.author",
    date: "26 Jul, 2025",
    dateKey: "sections.blogPosts.post_3.date",
    image: "assets/img/blog/recent-post-1-3.jpg",
    detailImage: [
      "assets/img/blog/blog-s-1-3.jpg",
      "assets/img/blog/blog-s-1-4.jpg"
    ],
    content: {
      intro: "In today's digital age, password security is more critical than ever. With cyber attacks becoming increasingly sophisticated, creating strong, unique passwords is your first line of defense.",
      introKey: "sections.blogPosts.post_3.content.intro",
      mainContent: "A strong password should be at least 12 characters long, combining uppercase and lowercase letters, numbers, and special symbols. Avoid using personal information, common words, or sequential patterns that hackers can easily guess.",
      mainContentKey: "sections.blogPosts.post_3.content.mainContent",
      quote: {
        text: "The security of your data is only as strong as your weakest password. Make every password count.",
        textKey: "sections.blogPosts.post_3.content.quote.text",
        author: "Bruce Schneier",
        authorKey: "sections.blogPosts.post_3.content.quote.author",
        designation: "Security Technologist & Author",
        designationKey: "sections.blogPosts.post_3.content.quote.designation"
      },
      middleContent: "Password managers are essential tools for maintaining unique passwords across all your accounts. They generate complex passwords and store them securely, eliminating need to remember dozens of different credentials.",
      middleContentKey: "sections.blogPosts.post_3.content.middleContent",
      conclusion: "Implementing two-factor authentication alongside strong passwords creates a robust security framework. Regular password updates and avoiding password reuse across platforms are crucial habits for maintaining digital security.",
      conclusionKey: "sections.blogPosts.post_3.content.conclusion"
    },
    tags: ["Password", "Protection"],
    category: "Endpoint Detection"
  }
  ,
  {
    id: 4,
    slug: "zero-trust-adoption",
    postType: "normal",
    title: "Zero Trust Adoption: Where Organizations Stand",
    titleKey: "sections.blogPosts.post_4.title",
    excerpt: "A look at how organizations are adopting zero-trust principles and practical steps to get started.",
    excerptKey: "sections.blogPosts.post_4.excerpt",
    author: "Secur",
    authorKey: "sections.blogPosts.post_4.author",
    date: "15 Aug, 2025",
    dateKey: "sections.blogPosts.post_4.date",
    image: "assets/img/blog/recent-post-1-4.jpg",
    detailImage: "assets/img/blog/blog-s-1-4.jpg",
    content: {
      intro: "Zero Trust is a security model that requires strict identity verification for every person and device trying to access resources on a private network.",
      introKey: "sections.blogPosts.post_4.content.intro",
      mainContent: "Adoption varies across industries, but many are moving toward identity-aware proxies, micro-segmentation, and stronger telemetry.",
      mainContentKey: "sections.blogPosts.post_4.content.mainContent"
    },
    tags: ["Zero Trust", "Strategy"],
    category: "Network Security"
  },
  {
    id: 5,
    slug: "securing-remote-workflows",
    postType: "normal",
    title: "Securing Remote Workflows: Tools & Tips",
    titleKey: "sections.blogPosts.post_5.title",
    excerpt: "Best practices and tools to keep remote teams secure while staying productive.",
    excerptKey: "sections.blogPosts.post_5.excerpt",
    author: "Secur",
    authorKey: "sections.blogPosts.post_5.author",
    date: "30 Sep, 2025",
    dateKey: "sections.blogPosts.post_5.date",
    image: "assets/img/blog/recent-post-1-5.jpg",
    detailImage: "assets/img/blog/blog-s-1-5.jpg",
    content: {
      intro: "Remote work introduces new risks — from unsecured home networks to device hygiene challenges.",
      introKey: "sections.blogPosts.post_5.content.intro",
      mainContent: "Combining endpoint detection, MFA, and secure access solutions reduces risk for distributed teams.",
      mainContentKey: "sections.blogPosts.post_5.content.mainContent"
    },
    tags: ["Remote", "Work"],
    category: "Endpoint Security"
  }
];

export default blogPosts;
